// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-range {
  -webkit-appearance: none;
  width: 100%;
  margin:  0;
  height: 6px;
  border-radius: 5px;
  outline: none;
}

input[type="range"].custom-range:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

input[type="range"].custom-range::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 6px;
  z-index: 1;
  border-radius: 5px;
  background: var(--slider-gradient, linear-gradient(to right, #206A5D 50%, #F6995C 50%))
}

.custom-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  z-index: 3;
  height: 20px;
  background: #206A5D;
  border: 3px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -6px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
}

.custom-thumb {
  position: absolute;
  width: 20px;
  z-index: 4;
  height: 20px;
  background: #206A5D;
  border: 3px solid #fff;
  transform: var(--transform-custom-thumb, translateX(0%));
  border-radius: 50%;
  cursor: pointer;
  margin-top: -6px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
}

.custom-range:disabled::-webkit-slider-thumb {
  cursor:  not-allowed;
}

.custom-range::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #206A5D;
  z-index: 3;
  border: 3px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
}

.custom-range::-ms-thumb {
  width: 20px;
  z-index: 3;
  height: 20px;
  background: #206A5D;
  border: 3px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
}

.fuel-percentages {
  height: 40px;
  min-height: 40px;
  transform: translateY(-15px);
  align-items: end;
}

.grade-name {
  margin-top: 3rem;
  margin: 0 auto;
}

.grade-value {
  background-color: #fff;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 4px 2px rgba(0, 0, 0, 0.1));
}

.grade-value-container {
  position: relative;
}

.grade-value-container::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -15px;
  z-index: 1;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 12px solid #FFF;
  filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1)); /* Adjust the shadow as needed */
}

.dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/views/range-slider/range-slider.component.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,8CAA8C,EAAE,gCAAgC;AAClF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[".custom-range {\r\n  -webkit-appearance: none;\r\n  width: 100%;\r\n  margin:  0;\r\n  height: 6px;\r\n  border-radius: 5px;\r\n  outline: none;\r\n}\r\n\r\ninput[type=\"range\"].custom-range:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\ninput[type=\"range\"].custom-range::-webkit-slider-runnable-track {\r\n  -webkit-appearance: none;\r\n  height: 6px;\r\n  z-index: 1;\r\n  border-radius: 5px;\r\n  background: var(--slider-gradient, linear-gradient(to right, #206A5D 50%, #F6995C 50%))\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 20px;\r\n  z-index: 3;\r\n  height: 20px;\r\n  background: #206A5D;\r\n  border: 3px solid #fff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  margin-top: -6px;\r\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)\r\n}\r\n\r\n.custom-thumb {\r\n  position: absolute;\r\n  width: 20px;\r\n  z-index: 4;\r\n  height: 20px;\r\n  background: #206A5D;\r\n  border: 3px solid #fff;\r\n  transform: var(--transform-custom-thumb, translateX(0%));\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  margin-top: -6px;\r\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)\r\n}\r\n\r\n.custom-range:disabled::-webkit-slider-thumb {\r\n  cursor:  not-allowed;\r\n}\r\n\r\n.custom-range::-moz-range-thumb {\r\n  width: 20px;\r\n  height: 20px;\r\n  background: #206A5D;\r\n  z-index: 3;\r\n  border: 3px solid #fff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)\r\n}\r\n\r\n.custom-range::-ms-thumb {\r\n  width: 20px;\r\n  z-index: 3;\r\n  height: 20px;\r\n  background: #206A5D;\r\n  border: 3px solid #fff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)\r\n}\r\n\r\n.fuel-percentages {\r\n  height: 40px;\r\n  min-height: 40px;\r\n  transform: translateY(-15px);\r\n  align-items: end;\r\n}\r\n\r\n.grade-name {\r\n  margin-top: 3rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.grade-value {\r\n  background-color: #fff;\r\n  position: relative;\r\n  z-index: 2;\r\n  filter: drop-shadow(0 4px 2px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.grade-value-container {\r\n  position: relative;\r\n}\r\n\r\n.grade-value-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 50%;\r\n  top: -15px;\r\n  z-index: 1;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-bottom: 12px solid #FFF;\r\n  filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1)); /* Adjust the shadow as needed */\r\n}\r\n\r\n.dot {\r\n  height: 8px;\r\n  width: 8px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-right: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
